<template>
	<div>
		<app-header></app-header>
		<div class="mt-70">
            <v-container grid-list-xl pt-0>
                <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 md8 lg6>
                        <v-card class="mb-4 font-14">
                            <div class="ma-2">
                                <span class="font-18">
                                    {{ $t("notification.notifications") }}
                                </span>
                                <span class="pointer hover-color right" @click="markAllAsRead">
                                    {{ $t("notification.markAllAsRead") }}
                                </span>
                            </div>
                        </v-card>
                        <div v-show="isShowNothingMessage">
                            <div class="font-20 text-center">
                                {{ $t("notification.nothingMessage") }}
                            </div>
                            <div class="font-12 text-center">
                                {{ $t("notification.mentionsMessage") }}
                            </div>
                        </div>
                        <!-- 无线下滑div -->
                        <div>
                            <v-card class="mb-2 px-3 py-3" v-for="(notification,index) in notificationList" :key="index">
                                <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                                <!-- - - - - - - - - - - - - 帖子点赞 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'POST_UPVOTE'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.postUpvote") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.post.postingTitle }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                                <!-- - - - - - - - - - - - - 帖子点踩 - - - - - - - - - - - - -->
                                <div  v-if="notification.type == 'POST_DOWNVOTE'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.postDownvote") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.post.postingTitle }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                                <!-- - - - - - - - - - - - - 帖子评论 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'POST_COMMENT'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.postComment") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.postComment.commentsContext }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 评论点赞 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'COMMENT_UPVOTE'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.commentUpvote") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.postComment.commentsContext }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 评论点踩 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'COMMENT_DOWNVOTE'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.commentDownvote") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.postComment.commentsContext }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 评论回复 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'COMMENT_REPLY'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.commentReply") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.postComment.commentsContext }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 用户关注 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'USER_FOLLOW'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.userFollow") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 用户取关 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'USER_UNFOLLOW'">
                                    <div>
                                        <v-avatar color="primary" class="pointer" size="30" @click="goUserData(notification.senderUserDetail.userName)">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar>
                                        <span @click="goUserData(notification.senderUserDetail.userName)" class="pl-2 pointer hover-color font-14 fw-700">
                                            {{notification.senderUserDetail.nickName}}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.userUnfollow") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 管理员帖子更新 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'ADMIN_POST_UPDATE'">
                                    <div>
                                        <v-avatar color="primary" size="30" >
                                            <img src="/static/icons/iob-sip-admin.jpg" alt="SIP">
                                        </v-avatar>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.adminPostUpdate") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.post.postingTitle }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 管理员帖子删除 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'ADMIN_POST_DELETE'">
                                    <div>
                                        <!-- <v-avatar color="primary" size="30">
                                            <img v-show="notification.senderUserDetail.image != null" :src="notification.senderUserDetail.image" :alt="notification.senderUserDetail.userName">
                                            <span v-show="notification.senderUserDetail.image == null"  class="headline white--text">{{notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                        </v-avatar> -->
                                        <v-avatar color="primary" size="30" >
                                            <img src="/static/icons/iob-sip-admin.jpg" alt="SIP">
                                        </v-avatar>
                                        <!-- <span class="pl-2 font-14 fw-700">
                                            {{ notification.senderUserDetail.nickName }}
                                            <span>({{notification.senderUserDetail.reputationScore}})</span>
                                        </span> -->
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.adminPostDelete") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 管理员评论更新 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'ADMIN_COMMENT_UPDATE'">
                                    <div>
                                        <v-avatar color="primary" size="30" >
                                            <img src="/static/icons/iob-sip-admin.jpg" alt="SIP">
                                        </v-avatar>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.adminCommentUpdate") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.postComment.commentsContext }}
                                    </div>
                                </div>
                                <!-- - - - - - - - - - - - - 管理员评论删除 - - - - - - - - - - - - -->
                                <div v-if="notification.type == 'ADMIN_COMMENT_DELETE'">
                                    <div>
                                        <v-avatar color="primary" size="30" >
                                            <img src="/static/icons/iob-sip-admin.jpg" alt="SIP">
                                        </v-avatar>
                                        <span class="ml-2 fw-600">
                                            {{ $t("notification.adminCommentDelete") }}
                                        </span>
                                        <span class="fw-700">·</span>
                                        <span class="fw-600">{{ dateFormat(notification.timestamp) }}</span>
                                        <span v-if="notification.isNotRead" class="right fw-700 pointer" @click="readNotification(notification)">
                                            <v-icon class="primary--text" size="12">fas fa-circle</v-icon>
                                        </span>
                                    </div>
                                    <div class="font-14 mt-2 pointer" @click="gotoPost(notification)">
                                        {{ notification.post.postingTitle }}
                                    </div>
                                </div>
                            </v-card>
                            <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
                            <infinite-loading @infinite="getNotificationList" class="mb-3">
                                <div slot="spinner">
                                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </div>
                                <div slot="no-more">{{$t("posting.noMore")}}</div>
                                <div slot="no-results">{{$t("posting.noResults")}}</div>
                            </infinite-loading>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg3 fill-height v-if="false">
                        <v-card>
                            <div class="ma-3 userDetail" v-for="(userInfo, index) in relatedUserInfoList" :key="index">
                                <div class="imgleft">
                                    <v-avatar color="primary" class="pointer" size="52" @click="goUserData(userInfo.userName)">
                                        <img v-show="userInfo.image != null" :src="userInfo.image" :alt="userInfo.userName">
                                        <span v-show="userInfo.image == null"  class="headline white--text">{{userInfo.userName.trim().substring(0, 1).toLocaleUpperCase() }}</span>
                                    </v-avatar>
                                </div>
                                <div class="right-side Author">
                                    <div class="ml-3">
                                        <span class="pointer hover-color font-14 fw-700" @click="goUserData(userInfo.userName)">
                                            <span >{{userInfo.nickName}}</span>
                                            <span>({{userInfo.reputationScore}})</span>
                                        </span>
                                        <span class="font-14 fw-500">@{{userInfo.userName}}</span>
                                    </div>
                                    <div class="ml-3">
                                        <v-btn color="primary" small @click="follow(userInfo)">
                                            <span v-show="userInfo.status == '0'">
                                                <Icon type="plus-round" color="#FFFFFF"></Icon>
                                                <span>{{$t("common.follow")}}</span>
                                            </span>
                                            <span v-show="userInfo.status == '1'">
                                                <span>{{$t("common.unfollow")}}</span>
                                            </span>
                                        </v-btn>
                                      </div>
                                </div>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import { mapGetters } from "vuex"
    import config from '../../config.js'
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        data(){
            return{
                isLoadingNotificationList: false,       // 是否正在加载通知集合
                isShowNothingMessage: false,            // 是否显示没有消息
                notificationList: [],                   // 消息通知的集合
                pageNo: 0,                              // 页码
                pageSize: 10,                           // 每次查询几条数据
                relatedUserInfoList:[],                 // 相关的推送用户集合
                formFollow: {                           //关注表单对象
                    userId: '',
                    followerId: '',
                }
            }
        },
        computed:{
            ...mapGetters(["user", "notificationNum"]),
        },
        created(){
            
        },
        mounted(){
            this.getRelatedUserInfoList();
        },
        components: {
            InfiniteLoading
        },
        watch:{
            
        },
        methods: {
            // 查询消息通知的集合
            getNotificationList($state){
                if (this.isLoadingNotificationList) {
                    return;
                }
                this.isLoadingNotificationList = true;
                let api = config.baseUrl + 'notification/query/getNotificationList?pageNo=' + this.pageNo + '&pageSize=' + this.pageSize;
                this.$http.get(api).then(response=> {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.pageNo += 1;
                        // 将心机和添加在已有集合的尾部
                        this.notificationList = [...this.notificationList, ...data.result];
                        this.isLoadingNotificationList = false;
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                    if (this.notificationList.length > 0) {
                        this.isShowNothingMessage = false;
                    } else {
                        this.isShowNothingMessage = true;
                    }
                })
            },
            // 更新已读下标
            updateReadIndex(readIndex){
                if (readIndex > this.user.readIndex) {
                    this.$http.get(config.baseUrl + 'userDetail/update/updateReadIndex?readIndex=' + readIndex).then(response=> {
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.$store.dispatch('readIndexHandler', data.result);
                        }
                    })
                }
            },
            // 阅读消息
            readNotification(notification){
                notification.isNotRead = false;
                this.$store.dispatch('notificationNumHandler', this.notificationNum - 1);
                this.updateReadIndex(notification.autoIndex);
            },
            // 标记所有为已读
            markAllAsRead(){
                this.$store.dispatch('notificationNumHandler', 0);
                this.updateReadIndex(this.notificationList[0].autoIndex);
                for(let i = 0; i < this.notificationList.length; i++){
                    this.notificationList[i].isNotRead = false;
                }
            },
            // 路由到查看用户详情页面
            goUserData(username) {
                this.$router.push({
                    name: "userData",
                    params: {
                      username: "@" + username
                    }
                });
            },
            //根据ID跳转到帖子详情页面
            gotoPost(notification) {
                if (notification.isNotRead) {
                    this.readNotification(notification);
                }
                var postId = "";
                switch (notification.type) {
                    case "POST_UPVOTE":
                        postId = notification.post.postingId;
                        break;
                    case "POST_DOWNVOTE":
                        postId = notification.post.postingId;
                        break;
                    case "POST_COMMENT":
                        postId = notification.postComment.commentsPostingId;
                        break;
                    case "COMMENT_UPVOTE":
                        postId = notification.postComment.commentsPostingId;
                        break;
                    case "COMMENT_DOWNVOTE":
                        postId = notification.postComment.commentsPostingId;
                        break;
                    case "COMMENT_REPLY":
                        postId = notification.postComment.commentsPostingId;
                        break;
                    case "ADMIN_POST_UPDATE":
                        postId = notification.post.postingId;
                        break;
                    case "ADMIN_COMMENT_UPDATE":
                        postId = notification.postComment.commentsPostingId;
                        break;
                    case "ADMIN_COMMENT_DELETE":
                        postId = notification.post.postingId;
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    name: 'postingsel',
                    params: {
                        postingId: postId,
                        username: ''
                    }
                });
            },
            // 查询相关的用户信息集合
            getRelatedUserInfoList(){
                for(let i=0;i<4;i++){
                    const user = {
                        userId: 1,
                        userName: 'test',
                        nickName: 'Test',
                        reputationScore: 30
                    }
                    this.relatedUserInfoList[i] = user;
                }
            },
            //关注
            follow(userInfo) {
                if (localStorage.getItem('token')) {
                    this.formFollow.userId = this.$store.state.user.id;
                    this.formFollow.followerId = userInfo.userId;
                    this.$http.post(config.baseUrl + "follow/saveFollow", this.formFollow).then((successData) => {
                        let data = successData.data;
                        if (data.resCode == 0) {
                            this.isFollow = true;
                        } else if (data.resCode == 1) {
                            this.isFollow = false;
                        } else if (data.resCode == -3) {
                            this.$Message.error("Can not follow yourself!");
                        }
                    });
                } else {
                    this.$store.state.loginModal = true;
                }
            },
            //格式化时间
            dateFormat(time) {
                let timeOffset = -28800000;
                if (this.user) {
                    timeOffset = this.user.timeOffset;
                }
                return formatDate(time, timeOffset, this.$i18n.locale);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Notification.vue?a4d50f50